import { UAParser } from 'ua-parser-js';
import { Device } from '@/interfaces/User.interface';

export function getDeviceInfo(): Device {
  const parser = new UAParser();
  const deviceInfo = parser.getDevice();
  const osInfo = parser.getOS();
  const browser = parser.getBrowser();

  return {
    model: browser.name || 'Unknown',
    manufacturer: deviceInfo.vendor || 'Unknown',
    osVersion: osInfo.version || 'Unknown',
  };
}
